import type {
  SyberryTodayPlanStatus,
  SyberryTodayPlanning,
  SyberryTodayProject,
  SyberryTodayTaskGroup,
  SyberryTodayTaskId,
  SyberryTodayTaskStream,
  SyberryTodayWorkItem,
} from '../types';

export type SyberryTodayPlanningState = {
  planStatus: SyberryTodayPlanStatus;
  projects: SyberryTodayProject[];
  groups: SyberryTodayTaskGroup[];
  streams: SyberryTodayTaskStream[];
  tasks: SyberryTodayWorkItem[];
  selectedTaskIds: SyberryTodayTaskId[];
  expandedTaskId: Nullable<SyberryTodayTaskId>;
  activeGroupId: Nullable<string>;
  isSkipCheckInModalOpen: boolean;
};

export enum SyberryTodayPlanningActionType {
  SYNC_PLANNING = 'syncPlanning',
  SET_ACTIVE_GROUP = 'setActiveGroup',
  SELECT_TASK = 'selectTask',
  DESELECT_TASK = 'deselectTask',
  TOGGLE_TASK_SELECTION = 'toggleTaskSelection',
  BACK_TO_TASK_SELECTION = 'backToTaskSelection',
  TOGGLE_TASK_EXPANSION = 'toggleTaskExpansion',
  OPEN_SKIP_CHECK_IN_MODAL = 'openSkipCheckInModal',
  CLOSE_SKIP_CHECK_IN_MODAL = 'closeSkipCheckInModal',
}

export type SyberryTodaySyncPlanningOptions = {
  closeSkipCheckInModal?: boolean;
};

export type SyberryTodayPlanningAction = {
  type: SyberryTodayPlanningActionType;
  planning?: SyberryTodayPlanning;
  groupId?: Nullable<string>;
  taskId?: SyberryTodayTaskId;
  syncOptions?: SyberryTodaySyncPlanningOptions;
};
